import { BlogContainer } from '@/modules/Blog';

export const Blog = (): JSX.Element => <BlogContainer />;

export default Blog;
